export default function WhyEducator() {
  const benefits = [
    {
      icon: 'ri-line-chart-line',
      title: 'キャリアの持続可能性',
      description:
        'ネイリストとしての現場作業には体力的な限界があります。エデュケーターとして、あなたの技術と経験を次世代に伝えることで、長期的なキャリアを築けます。',
      color: 'from-rose-400 to-pink-500',
      image:
        'https://public.readdy.ai/ai/img_res/638b9a0d048d947ae8a12543743862b3.jpg',
    },
    {
      icon: 'ri-group-line',
      title: '理想の人材を自分で育成',
      description: (
        <>
          新卒の教育コストや中途採用の社風リスクに悩む必要はありません。
          <br className="sm:hidden" />
          スクールを通じて、あなたの理念に共感する人材を一から育て、サロンの即戦力として迎えられます。
        </>
      ),
      color: 'from-amber-400 to-orange-500',
      image:
        'https://readdy.ai/api/search-image?query=nail%20instructor%20mentoring%20young%20students%20in%20bright%20training%20room%20hands-on%20teaching%20session%20building%20ideal%20team%20members%20professional%20education%20environment%20collaborative%20learning%20atmosphere%20clean%20organized%20workspace&width=600&height=400&seq=why002&orientation=landscape',
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: '安定した収益基盤',
      description:
        'スクール運営により、施術収入だけでなく、受講料や教材・商品の物販による収益も得られます。複数の収入源で、経営の安定性が大きく向上します。',
      color: 'from-emerald-400 to-teal-5 00',
      image:
        'https://readdy.ai/api/search-image?query=successful%20nail%20school%20business%20financial%20growth%20concept%20multiple%20revenue%20streams%20professional%20salon%20interior%20with%20training%20area%20modern%20elegant%20space%20prosperity%20and%20stability%20theme%20organized%20workspace&width=600&height=400&seq=why003&orientation=landscape',
    },
    {
      icon: 'ri-lightbulb-line',
      title: '業界への貢献と影響力',
      description:
        'ネイル業界全体のスタッフ不足問題の解決に貢献できます。あなたの知識と技術を広めることで、業界のリーダーとしての地位を確立できます。',
      color: 'from-purple-400 to-indigo-500',
      image:
        'https://readdy.ai/api/search-image?query=influential%20nail%20industry%20leader%20speaking%20at%20professional%20conference%20inspiring%20audience%20industry%20contribution%20concept%20modern%20seminar%20setting%20leadership%20and%20impact%20theme%20bright%20professional%20atmosphere&width=600&height=400&seq=why004&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-rose-50 via-white to-amber-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-white px-6 py-3 rounded-full shadow-md mb-6">
            <span className="text-sm font-black text-transparent bg-clip-text bg-gradient-to-r from-rose-600 to-amber-600 tracking-wider">
              WHY EDUCATOR
            </span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            なぜ今、<br className="sm:hidden" />エデュケーターが必要なのか
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ネイリストとしての<br className="sm:hidden" />次のステージへ。<br />
            スクール開講で、あなたのキャリアとビジネスが大きく変わります。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all"
            >
              <div className="relative h-56 overflow-hidden">
                <img src={benefit.image} alt={benefit.title} className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className={`absolute top-6 left-6 w-16 h-16 bg-gradient-to-br ${benefit.color} rounded-2xl flex items-center justify-center shadow-lg`}>
                  <i className={`${benefit.icon} text-3xl text-white`}></i>
                </div>
              </div>

              <div className="p-8">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                  {benefit.title === '理想の人材を自分で育成' ? (
                    <>
                      理想の人材を<br className="sm:hidden" />自分で育成
                    </>
                  ) : (
                    benefit.title
                  )}
                </h3>
                <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-pink-400 to-rose-400 rounded-3xl p-12 text-white text-center shadow-2xl">
          <h3 className="text-3xl font-bold mb-6">
            エデュケーター認定で、こんな未来が待っています
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="flex flex-col items-center">
              <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-4">
                <i className="ri-book-2-line text-4xl"></i>
              </div>
              <h4 className="font-bold text-base md:text-xl mb-2">公式テキストで教えられる</h4>
              <p className="text-white/90 text-sm">認定教材を使用した指導</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-4">
                <i className="ri-building-line text-4xl"></i>
              </div>
              <h4 className="font-bold text-base md:text-xl mb-2">スクールを運営できる</h4>
              <p className="text-white/90 text-sm">自分のスクールを開講</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-4">
                <i className="ri-team-line text-4xl"></i>
              </div>
              <h4 className="font-bold text-base md:text-xl mb-2">理想の人材を自分で育成</h4>
              <p className="text-white/90 text-sm">採用リスクを軽減</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mb-4">
                <i className="ri-trophy-line text-4xl"></i>
              </div>
              <h4 className="font-bold text-base md:text-xl mb-2">業界での信頼と地位を確立</h4>
              <p className="text-white/90 text-sm">認定資格による権威性</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}